import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { showFinancialPlanningSelector } from '../../AdviserArea/AdviserAreaSelector';

export enum IntegratedSystemType {
  OrionConnect = 'Orion Connect',
  Ally = 'Ally',
}

export interface IntegratedSystemsDTO {
  Id: string;
  Name: IntegratedSystemType;
}

interface ClientSettingsDTO {
  Settings: {
    IntegratedSystems: IntegratedSystemsDTO[];
    InheritedManagedAccountGrouping: boolean;
  };
}

export interface ClientSettingsData {
  integratedSystems: IntegratedSystemsDTO[];
  inheritedManagedAccountGrouping: boolean;
}

const parseClientSettings = (data: ClientSettingsDTO): ClientSettingsData => {
  return {
    integratedSystems: data.Settings.IntegratedSystems,
    inheritedManagedAccountGrouping: data.Settings.InheritedManagedAccountGrouping,
  };
};

interface FetchClientSettingsParams {
  clientId: string;
}

const fetchClientSettings = async ({
  clientId,
}: FetchClientSettingsParams): Promise<ClientSettingsData> => {
  const data = await authFetch(urlWithParams('/Consumer/ClientSettings', { clientId }));

  return parseClientSettings(data);
};

interface ClientAccessQueryParams {
  clientId: string;
}

export const useClientSettingsQuery = ({ clientId }: ClientAccessQueryParams) => {
  const showFinancialPlanning = useSelector(showFinancialPlanningSelector);

  return useQuery(
    queryKeys.clientSettings(clientId),

    () => fetchClientSettings({ clientId }),

    {
      enabled: !showFinancialPlanning,
      cacheTime: 0,
    },
  );
};
